(() => {
  const rail = document.querySelector('.shooting-carousel');
  if (!rail) return;
  const controls = document.querySelectorAll('[data-shooting-direction]');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const updateControls = () => controls.forEach(button => {
    const backwards = Number(button.dataset.shootingDirection) < 0;
    button.disabled = backwards ? rail.scrollLeft <= 2 : rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
  });
  const move = direction => {
    const sample = rail.querySelector('.shooting-sample');
    const gap = parseFloat(getComputedStyle(rail).gap) || 0;
    const step = sample.getBoundingClientRect().width + gap;
    rail.scrollBy({ left: direction * step, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
  };
  controls.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.shootingDirection))));
  rail.addEventListener('keydown', event => {
    if (event.target !== rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    move(event.key === 'ArrowLeft' ? -1 : 1);
  });
  rail.addEventListener('scroll', updateControls, { passive: true });
  new ResizeObserver(updateControls).observe(rail);
  updateControls();
})();
